/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_EmptyInputs */

const en_tools_empty = /** @type {(inputs: Tools_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, it's still empty — the admin hasn't had time to add the tools yet 😅`)
};

const id_tools_empty = /** @type {(inputs: Tools_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maap masih kosong, adminnya belum sempet nambah toolsnya nihh 😅`)
};

/**
* | output |
* | --- |
* | "Sorry, it's still empty — the admin hasn't had time to add the tools yet 😅" |
*
* @param {Tools_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tools_empty = /** @type {((inputs?: Tools_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tools_empty(inputs)
	return en_tools_empty(inputs)
});